export default __webpack_public_path__ + "static/media/six.09f72a59.jpg";